module.exports = __webpack_public_path__ + "static/img/part1.3413641.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/part1.png
// module id = z0kC
// module chunks = 0